module.exports = __webpack_public_path__ + "whatsapp-7896877998f935ce1ed5.svg";